import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { pluralizeWord } from 'utils/stringHelpers'
import {
  Bullet,
  Pipe,
  TextRow,
  StyledBodyCopy,
  StyledBodyCopyWithSpacing,
  SubHeaderWrapper,
} from './component.styles'

const InterventionsSubheader = ({ className, summary }) => {
  const {
    numberOfSites,
    smallGroupsCreated,
    groupsThatHaventCompletedLesson,
    lessonsCompleted,
  } = summary
  const numberOfSchoolsText = `**${numberOfSites}** ${pluralizeWord(
    numberOfSites,
    'School',
    'Schools',
  )} **•**`
  const smallGroupsCreatedText = `**${smallGroupsCreated}** ${pluralizeWord(
    smallGroupsCreated,
    'Small Group Created',
    'Small Groups Created',
  )}`
  const groupsThatHaventCompletedLessonText = `**${groupsThatHaventCompletedLesson}** ${pluralizeWord(
    groupsThatHaventCompletedLesson,
    "group hasn't",
    "groups haven't",
  )} completed a lesson`
  const lessonsCompletedText = `**${lessonsCompleted}** ${pluralizeWord(
    lessonsCompleted,
    'Lesson Completed',
    'Lessons Completed',
  )}`

  return (
    <SubHeaderWrapper className={className}>
      <TextRow>
        {numberOfSites > 1 && (
          <StyledBodyCopyWithSpacing>
            {numberOfSchoolsText}
          </StyledBodyCopyWithSpacing>
        )}
        <StyledBodyCopy>{smallGroupsCreatedText}</StyledBodyCopy>
        {groupsThatHaventCompletedLesson > 0 && (
          <Fragment key="groups-not-completed">
            <Pipe>{'|'}</Pipe>
            <Bullet />
            <StyledBodyCopy>
              {groupsThatHaventCompletedLessonText}
            </StyledBodyCopy>
          </Fragment>
        )}
      </TextRow>
      {numberOfSites > 1 && (
        <Fragment key="lessons-completed">
          <StyledBodyCopy>{lessonsCompletedText}</StyledBodyCopy>
        </Fragment>
      )}
    </SubHeaderWrapper>
  )
}

InterventionsSubheader.propTypes = {
  className: PropTypes.string,
  summary: PropTypes.shape({
    groupsThatHaventCompletedLesson: PropTypes.number.isRequired,
    lessonsCompleted: PropTypes.number.isRequired,
    numberOfSites: PropTypes.number.isRequired,
    smallGroupsCreated: PropTypes.number.isRequired,
  }).isRequired,
}

export default InterventionsSubheader
